import style from '../../../Home/Home.module.scss';
import className from "classnames/bind";
import {useState, useEffect} from "react";
import {Col, Row, Tag} from "antd";
import ActionBar from "~/layout/ActionBar";
import {
    Loading,
    Image
} from "~/components";
import {
    apiError,
    handleRequest,
    numberFormat,
    renderDate
} from "~/utils";
import {
    reportApi
} from "~/api";
import {ContractRankReportSearch} from "../../components";

const cn = className.bind(style);

function ContractRank()
{
    const [loading, setLoading] = useState(false);

    const [reportData, setReportData] = useState({
        website: [],
        host: [],
        extension: [],
    });

    const [filter, setFilter] = useState({});

    const handleLoad = async () =>
    {
        setLoading(true);

        let [error, response] = await handleRequest(reportApi.contractRanks(filter));

        let message = apiError(`Lấy thông tin báo cáo thất bại`, error, response);

        if (!message)
        {
            setReportData(response.data)
        }
        setLoading(false);
    }

    //Load data
    useEffect(() => {
        handleLoad().then();
    }, [filter]);


    //Search
    const handleFilterChange = (key, value) =>
    {
        setFilter({
            ...filter,
            [key]: value
        });
    };

    const CardRanks = ({name, items, cardColor}) => {
        return (
            <div className={cn('card', 'card-contract-ranks', cardColor)}>
                <h4 className={cn('heading')}>{name}</h4>
                <div className={cn('list-ranks')}>
                    {
                        items.map((item) => {
                            return <div key={`card-rank-${item.id}`} className={cn('contract')}>
                                <b className={cn('name')}>{item.code} {item.name}</b>
                                <div className={cn('contract-info')}>
                                    <div className={cn('status')}>
                                        <Tag color={item.service.badge}>{item.service?.label}</Tag>
                                        <Tag color={item.service.badge}>{item.serviceType?.label}</Tag>
                                        {(item?.package) && <Tag color={item.service?.badge}>{item?.package}</Tag>}
                                    </div>
                                    <div><p>{renderDate(item?.signing)}</p></div>
                                    <p className={cn('price')}>{numberFormat(item.price)}</p>
                                </div>
                                <div className={cn('users-info')}>
                                    <div className={cn('user')}>
                                        <div className={cn('avatar-rank', 'avatar')}><Image src={item.user.avatar} /></div>
                                        <div className={cn('info')}>
                                            <b className={cn('name')}>{item.user.firstname} {item.user.lastname}</b>
                                            <p className={cn('info-more')}>{item.user.username}</p>
                                        </div>
                                    </div>
                                    <div className={cn('user')}>
                                        <div className={cn('avatar-rank', 'avatar')}><Image src={item?.userShare?.avatar} /></div>
                                        <div className="info">
                                            <b className={cn('name')}>{item?.userShare?.firstname} {item?.userShare?.lastname}</b>
                                            <p className={cn('info-more')}>{item?.userShare?.username}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })
                    }
                </div>
            </div>
        )
    }

    return (
        <>
            <ActionBar title={'Xếp hạng hợp đồng'}></ActionBar>
            <div className="container d-block">
                <div className="content pd-1" style={{overflow:'auto'}}>
                    <ContractRankReportSearch filter={filter} onChange={handleFilterChange} />
                    {
                        loading && <Loading noFixed spin={true} />
                    }
                    {
                        !loading && <Row gutter={20}>
                            <Col span={8}>
                                <CardRanks
                                    name={'Hợp đồng website'}
                                    items={reportData.website}
                                    cardColor={'card-green'}
                                />
                            </Col>
                            <Col span={8}>
                                <CardRanks
                                    name={'Hợp đồng host'}
                                    items={reportData.host}
                                    cardColor={'card-red'}
                                />
                            </Col>
                            <Col span={8}>
                                <CardRanks
                                    name={'Hợp đồng gia hạn'}
                                    items={reportData.extension}
                                    cardColor={'card-yellow'}
                                />
                            </Col>
                        </Row>
                    }
                </div>
            </div>
        </>
    )
}

export default ContractRank;